<template>
  <v-select
    :value="value"
    @input="onInput"
    v-bind="$attrs"
    v-on="$listeners"
    :items="participantGroups"
    item-value="id"
    :item-text="item => (item.header ? item.header : item.name)"
    clearable
    return-object
  >
  </v-select>
</template>

<script>
import ApiService from "../../services/api.service";

export default {
  name: "ParticipantGroupField",
  props: {
    value: Object,
    status: { type: String, required: false }
  },
  data: () => ({
    participantGroups: []
  }),
  methods: {
    onInput(obj) {
      this.$emit("input", obj);
    }
  },
  mounted() {
    let filters = {};
    filters.isEffective = this.status;

    ApiService.post("/api/participantGroups/search?size=500&sort=category,ASC&sort=name,ASC", filters).then(
      ({ data }) => {
        let cleanData = (data.content || []).filter(pg => pg && pg.name && pg.name.trim() !== "");

        if (cleanData.length === 0) {
          this.participantGroups = [{ header: "No category" }];
          return;
        }

        let result = [];
        let last = null;

        cleanData.forEach(item => {
          let category = item.category || "No category";

          if (category !== last) {
            last = category;
            result.push({ header: category });
          }

          result.push(item);
        });

        this.participantGroups = result;
      }
    );
  }
};
</script>
